import { BASKET_TYPES, removeItemFromBasket, restoreBackup, selectBasket, sendBasket } from 'containers/OrderDetails/basketSlice'
import ReservationFailedPopup from 'layouts/Popups/ReservationFailedPopup'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

const FORM_PATHS = 'order|contract|login|registration|shop|payment'

const Reservation = () => {
  const { backup, time, lastSentTime, unlock = false, errors, list, invoice, paymentInProgress } = useSelector(selectBasket)
  const [reservation, setReservation] = useState(true)
  const { pathname } = useLocation()

  const { goBack, replace } = useHistory()
  const dispatch = useDispatch()

  const reg = new RegExp(`${unlock ? 'map|' : ''}${FORM_PATHS}`)
  const isFormPath = !!pathname.match(reg)

  const send = () => {
    dispatch(sendBasket({ step: 'rentingSummary' }))
  }

  useEffect(() => {
    if (time && !isFormPath) dispatch(removeItemFromBasket())
  }, [dispatch, isFormPath, time])

  useEffect(() => {
    if (!paymentInProgress && lastSentTime) {
      const time = lastSentTime - Date.now()
      const timeout = setTimeout(send, time)
      return () => {
        clearTimeout(timeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastSentTime, paymentInProgress])

  useEffect(() => {
    if (!paymentInProgress && isBasketValid(list)) {
      const timeout = setTimeout(send, 100)
      return () => {
        clearTimeout(timeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list, invoice, paymentInProgress])

  useEffect(() => {
    if (backup) {
      setReservation(!isFormPath)
      const timeout = setTimeout(() => { dispatch(restoreBackup(false)) }, 6000)
      return () => {
        clearTimeout(timeout)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, backup])

  if (errors) return <ReservationFailedPopup />
  if (!backup) return null
  return (
    <div className='notification'>
      <div className='notification__desc'>{reservation ? 'Nie dokończyłeś rezerwacji!' : 'Chcesz cofnąć akcję?'}</div>
      <div className='center --gap05'>
        <div className='notification__button --secFont' onClick={() => {
          dispatch(restoreBackup(true))
          if (!pathname.includes('order')) {
            const list = backup?.list
            const { identifier } = Array.isArray(list)
              ? (list.findLast(l => l.type === BASKET_TYPES.rent) || {})
              : {}
            if (identifier) replace(`/order/${identifier}`)
            else goBack()
          }
        }}>{reservation ? 'Wróć' : 'Cofnij'}</div>
        <div
          className='notification__button--close'
          onClick={() => {
            dispatch(restoreBackup(false))
          }}>
          <i className='icon icon--close' />
        </div>
      </div>
    </div>
  )
}

const isBasketValid = (list) => {
  if (!list || list.length === 0) return false
  for (const item of list) {
    if (item.type === BASKET_TYPES.rent && !item.ok) {
      return false
    }
  }
  return true
}

export default Reservation